// Tremor cx [v0.0.0]
// source: https://tremor.so/docs/utilities/cx#installation

import clsx, { type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cx(...args: ClassValue[]) {
    return twMerge(clsx(...args));
}
